<div *ngIf="!showAttachmentFlag" class="draft-template">
  <h2 style="margin-bottom: 5px" mat-dialog-title *ngIf="!showAttachmentFlag">
    {{ dialogData?.title ? dialogData?.title : "Edit Draft" }}
  </h2>
  <mat-dialog-content class="mat-typography" *ngIf="!showAttachmentFlag">
    <div>
      <div *ngIf="!dialogData?.flag">
        <mat-form-field style="width: 30%">
          <mat-label translate> Title </mat-label>
          <input [(ngModel)]="draftTitle" name="draftTitle" matInput />
        </mat-form-field>
      </div>
    </div>
    <div style="min-height: 400px">
      <ckeditor
        [data]="data"
        [(config)]="editorConfig"
        [readOnly]="readOnlyCkeditor"
        (ready)="onReady()"
        (change)="onChange($event)"
        (blur)="onBlur()"
      >
      </ckeditor>
      <!-- <dg-template #template [subject]="false" [header]="isHeader" [content]="isContent" [footer]="isFooter"
        [headerData]="headerData" [contentData]="contentData" [footerData]="footerData" [appId]="appId"
        [categoryId]="categoryId" [showTemplateSelection]="showTemplateSelection" (getCKData)="getCKData($event)"
        [fullBlock]="fullsection"></dg-template> -->
    </div>
  </mat-dialog-content>
</div>
<div *ngIf="showAttachmentFlag">
  <mat-dialog-content class="mat-typography">
    <div>
      <button (click)="closeAttachment()" class="float-end" mat-icon-button color="primary" type="button"
        *ngIf="!onlyPreview">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div>
      <h2 *ngIf="!onlyPreview">Preview Draft</h2>
      <h2 *ngIf="onlyPreview">{{ draftTitle }}</h2>
    </div>
    <div>
      <!-- <dg-file-upload
        *ngIf="onlyPreview"
        [title]="''"
        [viewAttach]="true"
        [attachId]="previewAttachID"
        [allowFileToAttach]="false"
        (onPreviewClose)="previewClose($event)"
      >
      </dg-file-upload> -->
      <!-- <img *ngIf="currentType == 'image'" [src]="previewSrc" width="100%" />
      <iframe
        *ngIf="currentType == 'pdf'"
        [src]="previewSrc"
        width="100%"
        height="480px"
      >
      </iframe> -->
      <mat-card>
        <mat-card-content>
          <div>
            <img *ngIf="currentType == 'image'" [src]="previewSrc" width="100%" height="480px" />
            <iframe *ngIf="currentType == 'pdf'" [src]="previewSrc" width="100%" height="480px" title="'hello'">
            </iframe>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-dialog-content>
</div>

<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>Cancel</button>
  <button color="primary" (click)="preview()" style="margin-right: 5px" mat-raised-button
    [disabled]="showAttachmentFlag || from == 'prepare'" *ngIf="!onlyPreview && !dialogData?.flag">
    Preview
  </button>
  <button color="primary" (click)="approve()" style="margin-right: 5px" mat-raised-button [disabled]="from == 'prepare'"
    *ngIf="!onlyPreview && !dialogData?.flag">
    Approve
  </button>
  <button color="primary" (click)="save('save&close')" style="margin-right: 5px" mat-raised-button
    *ngIf="!onlyPreview && !dialogData?.flag">
    Save & Close
  </button>
  <button color="primary" (click)="save('')" style="margin-right: 5px" mat-raised-button
    *ngIf="!onlyPreview && !dialogData?.flag">
    Save
  </button>
  <button color="primary" (click)="submit()" style="margin-right: 5px" mat-raised-button
    *ngIf="dialogData?.flag && dialogData?.showSubmit">
    Submit
  </button>
</mat-dialog-actions>